import { Serializable } from '@admin/core/models/serializable';

export class CustomerAgentDeleteResultModel
  implements Serializable<CustomerAgentDeleteResultModel>
{
  fromObject(obj: any): CustomerAgentDeleteResultModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public error: string;
  public errorCode: number;
}
